<div class="priority" [class]="priorityClass">
  <div class="prio-icon"><rotec-icon-v2 [svgIcon]="icon"></rotec-icon-v2></div>
  <div class="prio-text">{{ priority | translate }}</div>
</div>
